import React from 'react'
import PropTypes from "prop-types"
import { FormGroup, FormControl, ControlLabel, Col } from 'react-bootstrap'

import { getText } from '../lib/text'
import { checkDate } from "../timetable/timetable"

import "./AgendaItem/AgendaItem.less"

function ActivityTime({ activity, date, item, onChange }) {
  const check = (
    !activity.unknownAvailability 
    && checkDate(activity.timetable, date)
  )
  
  const closed = check && !check.open 
  
  if (!check || closed) return (
    <div className="ActivityDetailTime">
      {
        activity.unknownAvailability && (
          <div className="error">
            <span>
              Tripmaker no sabe la disponibilidad de esta actividad.
            </span>
          </div>
        )
      }
      {
        closed && (
          <div className="error">
            <span>
              Parece estar <b>cerrado</b> este día!
            </span>
          </div>
        )
      }
      <FormGroup className="customfg" as={Col}>
        <ControlLabel>{getText("Horario")}</ControlLabel>
        <FormControl
          value={item.time}
          onChange={evt => onChange(evt.target.value)}
        />
      </FormGroup>
    </div>
  )

  else if (activity.timetable.allDay) {
    return (
      <div className="ActivityDetailTime">
        <FormGroup className="customfg" as={Col}>
          <ControlLabel>{getText("Horario")}</ControlLabel>
          <FormControl
            value={item.time}
            onChange={evt => onChange(evt.target.value)}
          />
        </FormGroup>
        
        (Abierto: {check.allDayTimes.map(x => `${x.start} a ${x.end}`).join(", ")})
      </div>
    )
  }
  
  else {
    const custom = !(check.times.includes(item.time))
    
    return (
      <div className="ActivityDetailTime">
        <FormGroup className="selectfg">
          <ControlLabel>Turno</ControlLabel>
          <FormControl 
            componentClass="select"
            value={custom ? "_CUSTOM_" : item.time}
            onChange={evt => {
              const v = evt.target.value
              onChange(v == "_CUSTOM_" ? "" : v)
            }}
          >
            {
              check.times.map(time => (
                <option key={time} value={time}>{time}</option>
              ))
            }
            <option key="_CUSTOM_" value="_CUSTOM_">Otro... (a mano)</option>
          </FormControl>
        </FormGroup>
        
        {
          custom && (
            <FormGroup className="customfg" as={Col}>
              {/* <ControlLabel>{getText("Horario")}</ControlLabel> */}
              <FormControl value={item.time} onChange={evt => onChange(evt.target.value)} />
            </FormGroup>
          )
        }
      </div>
    )
  }
}

ActivityTime.propTypes = {
  activity: PropTypes.object.isRequired,
  date: PropTypes.object.isRequired, // moment
  item: PropTypes.object.isRequired, // agenda item
  onChange: PropTypes.func.isRequired,
}

export default ActivityTime
